import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_any_of_the_following_occur_during_or_after_industrial_actio'

export const dataPointDefinition = {
  retracedId: 'did_any_of_the_following_occur_during_or_after_industrial_actio',
  name: 'Did any of the following occur during or after industrial actions/strikes?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'NEW_WORKERS_WERE_HIRED_TO_REPLACE_STRIKING_WORKERS_DURING_INDUS',
      text: 'New workers were hired to replace striking workers during industrial actions/strikes',
      externalIds: [
        {
          id: 'foa-cb-7--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WERE_PUNISHED_FOR_PARTICIPATING_IN_INDUSTRIAL_ACTIONS_S',
      text: 'Workers were punished for participating in industrial actions/strikes',
      externalIds: [
        {
          id: 'foa-cb-7--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SECURITY_GUARDS_THE_POLICE_OR_ARMED_FORCES_WERE_CALLED_BY_THE_F',
      text: 'Security guards, the police, or armed forces were called by the facility to break up the industrial actions/strikes or arrest participating workers',
      externalIds: [
        {
          id: 'foa-cb-7--2-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'foa-cb-7--2-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'NEW_WORKERS_WERE_HIRED_TO_REPLACE_STRIKING_WORKERS_DURING_INDUS',
                'WORKERS_WERE_PUNISHED_FOR_PARTICIPATING_IN_INDUSTRIAL_ACTIONS_S',
                'SECURITY_GUARDS_THE_POLICE_OR_ARMED_FORCES_WERE_CALLED_BY_THE_F',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-58',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12560,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
